export const version = 'v2.2.4-1999-ga4357577e'
